import React from "react";
import PropTypes from "prop-types";
import Tooltip from "../../tooltip";
// eslint-disable-next-line import/no-cycle
import { isFunction, isString, isObject } from "../utils";

const BodyCell = ({ cellData, column, isScrolling }) => {
  const { truncateText, tooltip } = column;
  const tooltipResult = isFunction(tooltip) ? tooltip(cellData) : null;
  let tooltipConfig = { text: String(cellData) };

  if (tooltipResult) {
    if (isString(tooltipResult) || isFunction(tooltipResult)) {
      tooltipConfig = { text: tooltipResult };
    }

    /* istanbul ignore else */
    if (isObject(tooltipResult)) {
      tooltipConfig = tooltipResult;
    }
  }

  /* istanbul ignore else */

  if (tooltipConfig.text) {
    if (truncateText) {
      return isScrolling ? (
        <div className="oui-text-truncate">{cellData}</div>
      ) : (
        <Tooltip overflowOnly {...tooltipConfig}>
          <div className="oui-text-truncate">{cellData}</div>
        </Tooltip>
      );
    }

    if (tooltipResult && !isScrolling) {
      return (
        <Tooltip {...tooltipConfig}>
          <div>{cellData}</div>
        </Tooltip>
      );
    }
  }

  return cellData;
};

BodyCell.propTypes = {
  cellData: PropTypes.any,
  column: PropTypes.object,
  isScrolling: PropTypes.bool
};

export default BodyCell;
